@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.multi-package-count {
  padding: 5px 10px;
  border-top: 1px solid @multi-package-badge--count--border-color;
}

.multi-package-badge {
  border-radius: 4px;
  padding: 5px 10px;
  background-color: @multi-package-badge--background-color;
  display: inline-block;
  margin-right: 5px;
}
